import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageBusinessPlatinumCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Platinum Business Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-platinum-card.png',
  show: true,
  position: 'right'
};

export const BannerContentBusinessPlatinumCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Platinum Business Card Member',
  subtitle: ''
};

export const BannerBusinessPlatinumCardMocks: CardCarouselBanner = {
  labels: BannerContentBusinessPlatinumCardMocks,
  image: BannerImageBusinessPlatinumCardMocks
};
